import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslationService } from '../../../services/translation/translation.service';
import { InputStaticFieldsComponent } from "../../input-static-fields/input-static-fields.component";
import { Validation } from '../../../../admin-portal/components/user/service/user-validation';
import { SetPasswordService } from '../service/set-password.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../../services/loader/loader.service';
import { PageContentHeaderComponent } from "../../page-content-header/page-content-header.component";
import { CommonModule } from '@angular/common';
import { ToasterMessageService } from '../../../services/topbar-toaster/toaster-message.service';
import { AllRoutes } from '../../../common/all-routes';

@Component({
  selector: 'app-set-new-password',
  imports: [InputStaticFieldsComponent, ReactiveFormsModule, PageContentHeaderComponent,CommonModule],
  templateUrl: './set-new-password.component.html',
  styleUrl: './set-new-password.component.scss'
})
export class SetNewPasswordComponent implements OnInit {

  @Input() username!:string;
  @Input() previousPassword!:string;
  @Output() isPasswordChanged = new EventEmitter<void>();;
  @Output() modalDismiss = new EventEmitter<void>();

  newPasswordForm!: FormGroup;
  Validation = Validation
  errorMessage:boolean=false;
  errorMessageText:string = '';
  icon:string = 'fs-3 ti ti-bomb';

   // Password strength and validation states
  passwordStrength: string = '';
  passwordStrengthPercentage: number = 0;
  passwordRequirements = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  };


  private setPasswordService = inject (SetPasswordService);
  private translationService = inject (TranslationService);  
  public router = inject(Router);
  private loadingService = inject (LoaderService);

  constructor(public fb: FormBuilder,
        public messageService: ToasterMessageService,    
  ) {
   }
  ngOnInit(): void {
    this.newPasswordForm = this.fb.group({
      email: [this.username,[]],
      password: ['', this.Validation.user.PASSWORD.pattren],
      confirmPassword: ['', this.Validation.user.PASSWORD.pattren],
    });

    this.newPasswordForm
      .get('password')
      ?.valueChanges.subscribe((password: string) => {
        this.checkPasswordStrength(password);
      });
  }
  onSubmit(): void {
     
    if(this.passwordStrength !== 'Strong')
    {
      this.messageService.errroMessage("Please Enter Strong Password",true);
      return;
    }    
    if (this.newPasswordForm.valid) {
      if (this.newPasswordForm.value.password !== this.newPasswordForm.value.confirmPassword){
        this.errorMessageText = 'Password and Confirm Password should be matched.';
        this.errorMessage = true;
        return;
      }
      if (this.previousPassword === this.newPasswordForm.value.password) {
        this.errorMessage = true;
        this.errorMessageText = "Can't reuse old password.";
        return;
      }
      this.errorMessage = false;
      this.loadingService.showSpinner();
      this.setPasswordService.setPassword(this.newPasswordForm.value).subscribe({
        next: (data) => {
          this.closeModal();
          this.router.navigateByUrl(AllRoutes.LOGIN);
          // this.isPasswordChanged.emit()
          this.loadingService.stopSpinner();
        }, error: (err) => {
           
          this.loadingService.stopSpinner();
          this.errorMessage = true;
          this.errorMessageText = err.error.message;
          this.messageService.errroMessage(err.error.message, true);
        }
      })
    }
  }

  checkPasswordStrength(password: string) {
    if (!password) {
      this.passwordStrength = '';
      this.passwordStrengthPercentage = 0;
      this.passwordRequirements = {
        minLength: false,
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false,
      };
      return;
    }

    this.passwordRequirements = {
      minLength: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      // specialChar: /[@$!%*?&]/.test(password)
      specialChar: /[@$!%*?&#^()_+\-=\[\]\{\}\|\\:;"'<>,\.\/`]/.test(password),
    };

    const strengthScore = Object.values(this.passwordRequirements).filter(
      Boolean,
    ).length;
    if (strengthScore <= 2) {
      this.passwordStrength = 'Weak';
      this.passwordStrengthPercentage = 33;
    } else if (strengthScore <= 4) {
      this.passwordStrength = 'Medium';
      this.passwordStrengthPercentage = 66;
    } else {
      this.passwordStrength = 'Strong';
      this.passwordStrengthPercentage = 100;
    }
  }


  closeModal() {
    this.modalDismiss.emit();
  }
  translate(key: string): string {
    return this.translationService.translate(key);
  }
  close(){
    this.errorMessage =false
  }
}
